/**
 * Headless UI Dialog portals modal backdrops to document.body. If a Dialog is
 * unmounted mid-transition (viewport resize, fast route change, bfcache restore),
 * the semi-transparent scrim can remain and block the entire app.
 */
export function releaseStuckModalOverlays(): void {
  const html = document.documentElement
  const body = document.body
  const root = document.getElementById('root')

  html.style.overflow = ''
  html.style.paddingRight = ''
  body.style.overflow = ''
  body.style.paddingRight = ''
  body.removeAttribute('data-scroll-lock')

  root?.removeAttribute('inert')
  root?.removeAttribute('aria-hidden')

  document.querySelectorAll('[inert]').forEach((el) => {
    if (el === root || root?.contains(el)) {
      el.removeAttribute('inert')
    }
  })

  // Headless UI v2 portal roots (e.g. headlessui-portal-root).
  document.querySelectorAll('[id^="headlessui-"]').forEach((portal) => {
    if (portal.contains(root)) return
    const hasOpenDialog = portal.querySelector('[role="dialog"]:not([hidden])')
    if (!hasOpenDialog) {
      portal.remove()
    }
  })

  // Orphan full-screen scrims portaled outside #root (sidebar + page modals).
  body.querySelectorAll(':scope > div').forEach((el) => {
    if (root?.contains(el)) return
    const scrim = el.matches('.fixed.inset-0')
      ? el
      : el.querySelector(':scope > .fixed.inset-0')
    if (!scrim || !(scrim instanceof HTMLElement)) return

    const className = scrim.className
    const looksLikeModalScrim =
      /bg-gray-600|bg-black|bg-slate-900/.test(className) &&
      (/bg-opacity|\/\d+|opacity-/.test(className) || className.includes('backdrop-blur'))

    if (looksLikeModalScrim && !el.querySelector('[role="dialog"]')) {
      el.remove()
    }
  })
}
